import { parse } from 'hub-http/helpers/params';
import PortalIdContainer from '../portal-id-container/PortalIdContainer';
import { getRouteParams } from '../routing/getRouteParams';
import { getHublet } from '../store/app/selectors';
import { checkAuth } from './checkAuthApi';
import { setAuth, setAuthHubless } from './setAuth';

const init = () => (dispatch, getState) => {
  const state = getState();
  const hublet = getHublet(state);
  return checkAuth(hublet).then(auth => {
    const {
      hubIds = []
    } = auth;

    if (hubIds.length) {
      PortalIdContainer.set(PortalIdContainer.get() || hubIds[0]);
      dispatch(setAuth(auth));
    } else {
      dispatch(setAuthHubless(auth));
    }

    return auth;
  });
};

export const Auth = {
  init
};
export const getGatesWithUrlOverrides = gates => {
  const {
    gates: overrideGates
  } = parse(getRouteParams().search);

  if (!overrideGates) {
    return gates;
  }

  if (!Array.isArray(overrideGates)) {
    return [...gates, overrideGates];
  }

  return [...gates, ...overrideGates];
};
export const getLoginStatusFromResponse = response => {
  let status;

  if (Array.isArray(response) && Object.keys(response[0]).includes('status')) {
    status = response[0].status;
  }

  return status;
};